import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export function CardSkeleton({ rows = 3 }) {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="card-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="soft-card rounded-2xl p-5">
          <Skeleton className="h-5 w-2/3 mb-3" />
          <Skeleton className="h-3 w-1/3 mb-4" />
          <Skeleton className="h-3 w-full mb-1.5" />
          <Skeleton className="h-3 w-5/6" />
        </div>
      ))}
    </div>
  );
}

export function RowSkeleton({ rows = 3 }) {
  return (
    <div className="space-y-2" data-testid="row-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="soft-card rounded-2xl p-5 flex items-center gap-4">
          <Skeleton className="h-12 w-12 rounded-full" />
          <div className="flex-1">
            <Skeleton className="h-4 w-2/5 mb-2" />
            <Skeleton className="h-3 w-1/4" />
          </div>
          <Skeleton className="h-8 w-24 rounded-lg" />
        </div>
      ))}
    </div>
  );
}

export function StatSkeleton({ count = 4 }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="stat-skeleton">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="soft-card rounded-xl p-4">
          <Skeleton className="h-3 w-1/2 mb-2" />
          <Skeleton className="h-7 w-1/3" />
        </div>
      ))}
    </div>
  );
}
